import { Grid, Tag } from '@optimus-web/core';

interface KeyboardShortcutProps {
    keyboardShortcut: string[];
}

export const KeyboardShortcut = ({ keyboardShortcut }: KeyboardShortcutProps) => (
    <Grid templateColumns="min-content min-content min-content" columnGap="25" style={{ justifySelf: 'end' }}>
        {keyboardShortcut.map((value) => (
            <Tag variant="basicSubtle" key={value}>
                {value}
            </Tag>
        ))}
    </Grid>
);
